import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-31f9e048"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "selLang"
};
import { XlSelect } from '@shining3d/ui-components';
import { VueCookieNext } from 'vue-cookie-next';
import { useStore } from 'vuex';
import { $setLang } from '@/assets/common/common.js';
export default {
  setup: function setup(__props) {
    var $store = useStore();
    var lang = ref(VueCookieNext.getCookie('lang'));
    function onChange(params) {
      $setLang(params);
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(XlSelect), {
        options: _unref($store).state.langs,
        modelValue: lang.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return lang.value = $event;
        }),
        onChange: onChange
      }, _createSlots({
        _: 2
      }, [_ctx.$slots.default ? {
        name: "prefix",
        fn: _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "default")];
        })
      } : undefined]), 1032, ["options", "modelValue"])]);
    };
  }
};